/**
 * Helper format tampilan untuk area admin (tanggal/waktu WIB + warna badge).
 */
const WIB = "Asia/Jakarta";

export function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d)) return String(value);
  return d.toLocaleDateString("id-ID", { timeZone: WIB, day: "2-digit", month: "short", year: "numeric" });
}

export function formatTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d)) return String(value);
  return d.toLocaleTimeString("id-ID", { timeZone: WIB, hour: "2-digit", minute: "2-digit" });
}

export function formatDateTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d)) return String(value);
  return `${formatDate(value)} ${formatTime(value)}`;
}

export function formatMinutes(min) {
  if (min == null) return "-";
  const h = Math.floor(min / 60);
  const m = min % 60;
  return h === 0 ? `${m}m` : `${h}j ${m}m`;
}

export function attendanceFlagColor(flag) {
  switch (flag) {
    case "NORMAL":
      return "green";
    case "LATE":
    case "HALF_DAY":
    case "EARLY_OUT":
      return "yellow";
    case "WFH":
    case "MANUAL_EDIT":
    case "CUTI":
      return "blue";
    case "REJECTED":
    case "FORGOT_CHECKIN":
    case "FORGOT_CHECKOUT":
    case "DOUBLE_CHECKIN":
    case "DOUBLE_CHECKOUT":
    case "ABSENT":
      return "red";
    default:
      return "gray";
  }
}

/** Label ramah untuk flag absensi (status virtual "Absen"/"Cuti" diterjemahkan). */
export function attendanceStatusLabel(flag) {
  switch (flag) {
    case "ABSENT":
      return "Absen";
    case "CUTI":
      return "Cuti";
    default:
      return flag || "-";
  }
}

/** Label ramah (bahasa tampilan) untuk status absensi — dipakai kalender, list & anomali. */
export const ATTENDANCE_STATUS_TEXT = {
  NORMAL: "Hadir",
  LATE: "Telat",
  HALF_DAY: "Half Day",
  EARLY_OUT: "Pulang Awal",
  WFH: "WFH",
  MANUAL_EDIT: "Manual",
  FORGOT_CHECKIN: "Lupa Check-in",
  FORGOT_CHECKOUT: "Lupa Check-out",
  DOUBLE_CHECKIN: "Double Check-in",
  DOUBLE_CHECKOUT: "Double Check-out",
  REJECTED: "Ditolak",
  ABSENT: "Absen",
  CUTI: "Cuti",
};
export const attendanceStatusText = (s) => ATTENDANCE_STATUS_TEXT[s] || s || "-";

/** Penjelasan singkat tiap jenis anomali (ditangani Odoo, bukan approval). */
export const ANOMALY_HINT = {
  FORGOT_CHECKIN: "Ada check-out tanpa check-in — Odoo yang menautkan/menandai.",
  FORGOT_CHECKOUT: "Ada check-in tanpa check-out — dikirim sebagai baris terbuka, Odoo/HRD menutup.",
  DOUBLE_CHECKIN: "Terdeteksi check-in ganda pada hari yang sama.",
  DOUBLE_CHECKOUT: "Terdeteksi check-out ganda pada hari yang sama.",
};

export function approvalStatusColor(status) {
  switch (status) {
    case "APPROVED":
      return "green";
    case "REJECTED":
      return "red";
    case "NEED_APPROVAL":
    case "PENDING_MANAGER":
    case "PENDING":
      return "yellow";
    default:
      return "gray";
  }
}

export function leaveStatusColor(status) {
  switch (status) {
    case "APPROVED":
      return "green";
    case "REJECTED":
      return "red";
    case "PENDING":
      return "yellow";
    case "CANCELLED":
      return "gray";
    default:
      return "gray";
  }
}

export function userStatusColor(status) {
  switch (status) {
    case "active":
      return "green";
    case "pending":
      return "yellow";
    case "inactive":
      return "gray";
    case "suspended":
      return "red";
    default:
      return "gray";
  }
}

/** Label ramah untuk status akun. */
export function userStatusLabel(status) {
  switch (status) {
    case "active":
      return "Aktif";
    case "pending":
      return "Belum login";
    case "inactive":
      return "Nonaktif";
    case "suspended":
      return "Suspend";
    default:
      return status || "-";
  }
}
